<template>
  <v-row class="title-block">
    <v-col class="mt-10">
      <h3><CharSplitText :text="data.text" /></h3>
    </v-col>
  </v-row>
</template>

<script>
import CharSplitText from '@/atoms/CharSplitText'

export default {
  name: 'ContentTitle',
  components: { CharSplitText },
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.mt-25 {
  margin-top: 100px !important;
}
</style>
